import { render, staticRenderFns } from "./ScholarDetailFunding.vue?vue&type=template&id=c40fa682&lang=pug&"
import script from "./ScholarDetailFunding.vue?vue&type=script&lang=js&"
export * from "./ScholarDetailFunding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports